<template>
  <div class="system-header-wrapper">
    <div class="system-header">
      <div class="search-input">
        <el-input placeholder="搜索关键词" v-model="searchValue" @keyup.enter.native="search()">
          <el-image
            slot="prefix"
            style="
              width: 25px;
              height: 25px;
              position: absolute;
              top: 8px;
              left: 15px;
              padding: 3px 0 0 3px;
            "
            :src="searchUrl"
          />
        </el-input>
      </div>
      <div class="search-hot">
        <div class="search-left">
          <el-image :src="hotUrl" ></el-image>
          <span>热搜:</span>
        </div>
        <el-link
          v-for="(item, index) in hotKeywordList"
          :key="index"
          :underline="false"
          @click.native="search(item.name)"
          >{{ item.name }}</el-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
// import { SEARCH_KEYWORDS } from '@/constants'
import searchUrl from './assets/search.png'
import hotUrl from './assets/hot.png'

export default {
  data() {
    return {
      searchUrl,
      hotUrl,
      keyword: '',
      type: ''
    }
  },
  computed: {
    searchValue: {
      get() {
        return this.$store.state.home.searchValue
      },
      set(newVal) {
        this.updateSearchValue(newVal)
      }
    },
    ...mapState({
      hotKeywordList: state => state.home.hotKeyword
    })
  },
  watch: {
    $route(to, from) {
      if (to.params.type !== from.params.type) {
        this.type = to.params.type
      }
      if (to.query.keyword !== from.query.keyword) {
        this.keyword = to.query.keyword
      }
    }
  },
  methods: {
    ...mapActions('home', ['getHotKeyword']),
    ...mapMutations('home', ['updateSearchValue']),
    handleSearch() {
      const { keyword } = this
      this.$router.push(`/application/list/-1?keyword=${encodeURIComponent(keyword || '')}`)
    },
    handleKeyup(e) {
      if (e && e.keyCode === 13) {
        this.handleSearch()
      }
    },
    handleKeywordClick(keyword) {
      this.keyword = keyword
      this.handleSearch()
    },
    dropDownShow(e, index) {
      // if (e) {
      //   let parentDomWidth = document.body.getElementsByClassName('el-dropdown')
      //   setTimeout(() => {
      //     let dropDownUlDOM = document.body.getElementsByClassName('category-second' + index)[0]
      //     console.log(document.body.getElementsByClassName('el-dropdown-link')[index].offsetWidth)
      //     // dropDownUlDOM.style.left = parentDomWidth[index + 2].offsetLeft-(document.body.getElementsByClassName('el-dropdown-link')[index].offsetWidth/2)+'px';
      //     dropDownUlDOM.style.left = parentDomWidth[index + 2].offsetLeft+'px';
      //   },60)
      // }
    },
    search(name) {
      if (name) {
        this.searchValue = name
      } else if (!name) {
        name = this.searchValue
      } else {
        name = ''
      }
      this.$router.push('/search/' + name)
    }
  },
  created() {
    const { keyword } = this.$route.query
    const { type } = this.$route.params
    this.keyword = keyword
    this.type = type
    this.getHotKeyword()
  }
}
</script>

<style lang="less">
.system-header-wrapper {
  width: 100%;
  background: #ffffff;
  .system-header {
    width: 1200px;

    margin: 0 auto;
    height: 80px;
    .search-input,
    .search-hot,
    .hot-value {
      display: inline-block;
    }
    .search-input {
      width: 430px;
      height: 48px;
      margin-right: 50px;
      .el-input__inner {
        background: #f5f5f5;
        border-radius: 24px;
        border: 1px #f5f5f5 solid;
        height: 48px;
        line-height: 48px;
        &:focus,
        &:hover {
          border: 1px #007dff solid;
        }
      }
      .el-input--prefix .el-input__inner {
        padding-left: 57px;
      }
      .el-input__inner::placeholder {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #a2a2a2;
        line-height: 22px;
      }
    }

    .search-hot {
      vertical-align: top;
      height: 48px;
      line-height: 48px;
      .el-link.el-link--default {
        color: #333333;
        margin-left: 14px;
      }
      .el-link.el-link--default:hover {
        color: #0091ff;
      }
      .el-link--inner {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
      }
      .search-left {
        display: inline-block;
        // vertical-align: middle;
        .el-image {
          width: 12px;
          height: 17px;
          vertical-align: middle;
        }
        span {
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff3b30;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SystemHeader/index.vue